module.exports = __webpack_public_path__ + "fd5a608a/img/34000000-7.b91fb151.png";